// only 1 Student Assistant Panel can be active at a time per page

import { Panel } from "./panel";

class Manager {
    private activePanel: Panel | undefined;
    private static instance: Manager;
    private readonly registeredPanels: Map<string, Panel> = new Map();

    // Static convenience method for student assistant buttons to call in their onClick handlers
    public static open(
        button: HTMLButtonElement,
        questionId: string,
        userId: string,
        deploymentId?: string,
    ) {
        if (!Manager.instance) {
            Manager.instance = new Manager();
        }

        Manager.instance.toggle(button, questionId, userId, deploymentId);
    }

    private toggle(
        button: HTMLButtonElement,
        questionId: string,
        userId: string,
        deploymentId?: string,
    ) {
        // Close previous, if any
        if (this.activePanel?.questionId !== questionId) {
            this.activePanel?.close();
        }

        // Check for a registered panel for this question. If not found, then create and register.
        this.activePanel = this.registeredPanels.get(questionId);
        if (!this.activePanel) {
            this.registeredPanels.set(
                questionId,
                new Panel(button, questionId, userId, deploymentId),
            );
            this.activePanel = this.registeredPanels.get(questionId);
        }

        // At this point we should have an active panel
        if (!this.activePanel) {
            return;
        }

        this.activePanel.open();
    }
}

export { Manager };
